@if (isDemo && authPageService.loading()) {
    <span> {{ "sign_up.creating_acc_desc_2" | translate }} </span>
} @else {
    <form [formGroup]="signUpForm" autocomplete="off" data-testid="sign-up-form">
        <div class="input-group-wrapper-feedback">
            <label for="country-select">{{ "misc.country" | translate }}</label>
            <ng-select
                id="country-select"
                data-testid="sign-up-form-country-select"
                [items]="countryService.sortedCountriesWithCodes()"
                bindLabel="name"
                bindValue="code"
                placeholder="{{ 'sign_up.choose_country' | translate }}"
                formControlName="country_code"
                [searchable]="true"
                [clearable]="false"
            >
            </ng-select>
            <div class="feedback-container">
                @if (formSubmitted && country_code?.invalid) {
                    @if (country_code?.errors?.required) {
                        <div class="error-msg">
                            {{ "sign_up.country_req" | translate }}
                        </div>
                    }
                }
            </div>
        </div>

        @if (!isDemo) {
            @if (authPageService.isCompanyIndividualSignUp()) {
                <div class="input-group-wrapper-feedback business-type-picker">
                    <div>
                        <label for="businessType">{{ "sign_up.business_type" | translate }}</label>
                    </div>
                    <mat-radio-group formControlName="businessType" aria-label="Business Type" id="businessType" class="vertical-radio-group" data-testid="sign-up-form-business-type-radio-group">
                        <mat-radio-button value="company" data-testid="sign-up-form-business-type-company-radio">
                            <span class="aw-radio-label-span">{{ "sign_up.company_partnership" | translate }}</span>
                        </mat-radio-button>
                        <mat-radio-button value="individual" data-testid="sign-up-form-business-type-individual-radio">
                            <span class="aw-radio-label-span">{{ "sign_up.individual_person" | translate }}</span>
                        </mat-radio-button>
                    </mat-radio-group>
                    <div class="feedback-container">
                        @if (formSubmitted && businessType?.invalid) {
                            @if (businessType?.errors?.required) {
                                <div class="error-msg">
                                    {{ "sign_up.business_type_req" | translate }}
                                </div>
                            }
                        }
                    </div>
                </div>
            }
        }

        <div class="input-group-wrapper-feedback">
            <label for="email">{{ "misc.email" | translate }}</label>
            <input class="form-control" type="email" autocomplete="email" id="email" name="email" formControlName="email" data-testid="sign-up-form-email-input" />
            <div class="feedback-container">
                @if (formSubmitted && email?.invalid) {
                    @if (email?.errors?.required) {
                        <div class="error-msg">
                            {{ "misc.email_required" | translate }}
                        </div>
                    }
                }
            </div>
        </div>

        <div class="input-group-wrapper-feedback">
            <label for="password">{{ "misc.password" | translate }}</label>
            <input autocomplete="new-password" id="password" name="password" class="form-control" type="password" formControlName="password" data-testid="sign-up-form-password-input" />
            <div class="feedback-container">
                @if (formSubmitted && password?.invalid) {
                    @if (password?.errors?.required) {
                        <div class="error-msg">
                            {{ "misc.password_required" | translate }}
                        </div>
                    }
                    @if (password?.errors?.maxlength) {
                        <div class="error-msg">
                            {{ "misc.password_too_long" | translate }}
                        </div>
                    }
                    @if (password?.errors?.minlength) {
                        <div class="error-msg">
                            {{ "misc.password_too_short" | translate }}
                        </div>
                    }
                    @if (password?.errors?.weakPassword) {
                        <div class="error-msg">
                            {{ "misc.password_is_weak" | translate }}
                        </div>
                    }
                }
            </div>
        </div>

        <div class="input-group-wrapper-feedback">
            <label for="repeatPassword">{{ "sign_up.repeat_password" | translate }}</label>
            <input autocomplete="new-repeatPassword" name="repeatPassword" id="repeatPassword" class="form-control" type="password" formControlName="repeatPassword" data-testid="sign-up-form-repeat-password-input" />
            <div class="feedback-container">
                @if (formSubmitted && repeatPassword?.invalid) {
                    @if (repeatPassword?.errors?.required) {
                        <div class="error-msg">
                            {{ "sign_up.password_need_repeat" | translate }}
                        </div>
                    }
                    @if (repeatPassword?.errors && repeatPassword?.errors?.pwNoMatch) {
                        <div class="error-msg">
                            {{ "sign_up.password_not_matching" | translate }}
                        </div>
                    }
                }
            </div>
        </div>

        <div class="input-group-wrapper-feedback">
            <div class="checkbox">
                <app-aw-checkbox id="terms_check" dataTestId="sign-up-form-terms-checkbox" [disabled]="termsOfUseAndGDPRDisabled" [checkbox]="termsChecked" [initialCheckedValue]="termsChecked" (checkStateEmitter)="toggleConsent('terms')" />
                <label for="terms_check">
                    {{ "sign_up.accept" | translate }}
                    @if (!termsOfUseAndGDPRDisabled) {
                        <a class="primary-color" href="{{ pickedRegion === 'us' ? usTermsOfUse : euTermsOfUse }}" target="_blank" tabindex="-1">{{ "sign_up.terms_n_conds" | translate }}</a>
                    }
                    @if (termsOfUseAndGDPRDisabled) {
                        <span class="primary-color">{{ "sign_up.terms_n_conds" | translate }}</span>
                    }
                </label>
            </div>
            <div class="feedback-container">
                @if (formSubmitted && !termsChecked) {
                    <div class="error-msg">
                        {{ "sign_up.terms_need_accept" | translate }}
                    </div>
                }
            </div>
        </div>

        <div class="input-group-wrapper-feedback terms">
            <div class="checkbox">
                <app-aw-checkbox id="gdpr_check" dataTestId="sign-up-form-gdpr-checkbox" [disabled]="termsOfUseAndGDPRDisabled" [checkbox]="gdprChecked" [initialCheckedValue]="gdprChecked" (checkStateEmitter)="toggleConsent('gdpr')" />
                <label for="gdpr_check">
                    {{ "sign_up.accept" | translate }}
                    @if (!termsOfUseAndGDPRDisabled) {
                        <a class="primary-color" href="{{ gdprPolicy }}" target="_blank" tabindex="-1">{{ "misc.gdpr" | translate }}</a>
                    }
                    @if (termsOfUseAndGDPRDisabled) {
                        <span class="primary-color" href="{{ gdprPolicy }}">{{ "misc.gdpr" | translate }}</span>
                    }
                </label>
            </div>
            <div class="feedback-container">
                @if (formSubmitted && !gdprChecked) {
                    <div class="error-msg">
                        {{ "sign_up.gdpr_needs_accept" | translate }}
                    </div>
                }
            </div>
        </div>
    </form>
}
